import { setupInterceptors } from '@wajeez-web/core/api';
import { createStore } from '@wajeez-web/stores/base';
import { injectAuthReducers } from '@wajeez-web/stores/auth';
import { injectCommonReducers } from '@wajeez-web/stores/common';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { i18n } from '@wajeez-web/core/utils';
import { injectProductReducers } from '@wajeez-web/stores/product';
import { injectBusinessReducers } from '@wajeez-web/stores/business-group';
import { injectCustomerReducers } from '@wajeez-web/stores/customers';
import { injectAppwatchReducers } from '@wajeez-web/stores/appwatch';
import { injectRolesReducers } from '@wajeez-web/stores/roles';
import { injectContentReducers } from '@wajeez-web/stores/content';
import { injectAccountReducers } from '@wajeez-web/stores/account';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallbackWithoutReset } from '@wajeez-web/components/ui';
import 'antd/dist/reset.css';

import App from './app/app';

setupInterceptors();

const store = createStore([
  injectCommonReducers,
  injectAuthReducers,
  injectProductReducers,
  injectBusinessReducers,
  injectContentReducers,
  injectCustomerReducers,
  injectRolesReducers,
  injectAppwatchReducers,
  injectAccountReducers,
]);

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer as unknown as any, rtlPlugin as unknown as any],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ErrorBoundary
    FallbackComponent={ErrorFallbackWithoutReset}
    onReset={(details) => {
      console.log(details);
    }}
  >
    <Provider store={store}>
      {/* <StrictMode> */}
      <I18nextProvider i18n={i18n}>
        {/* <BrowserRouter> */}
        <CacheProvider value={cacheRtl}>
          <App />
        </CacheProvider>
        {/* </BrowserRouter> */}
      </I18nextProvider>
      {/* </StrictMode> */}
    </Provider>
  </ErrorBoundary>
);
